import type { PublicPage } from '@makerstack/page-render'
import type { Doc } from './api'

type Draft = Doc<'pages'>['draft']
export type StartupRow = Doc<'pageStartups'> & { iconUrl?: string | null }

/** A partial patch to the draft (nested social/emailCollection merged by caller). */
export type DraftPatch = Partial<Omit<Draft, 'social' | 'emailCollection' | 'avatarStorageId'>> & {
  avatarStorageId?: Doc<'pages'>['draft']['avatarStorageId'] | null
  social?: Partial<Draft['social']>
  emailCollection?: Partial<Draft['emailCollection']>
}

/** Build a PublicPage (for the live preview) from the editable draft state. */
export function draftToPublicPage(
  username: string,
  draft: Draft,
  avatarUrl: string | null | undefined,
  startups: StartupRow[],
): PublicPage {
  return {
    username,
    displayName: draft.displayName || 'Your name',
    avatarUrl: avatarUrl ?? undefined,
    bio: draft.bio,
    location: draft.location,
    social: draft.social ?? {},
    theme: draft.theme,
    font: draft.font,
    emailCollection: {
      enabled: draft.emailCollection?.enabled ?? false,
      headline: draft.emailCollection?.headline,
    },
    startups: startups
      .filter((s) => s.visible)
      .map((s) => ({
        name: s.name,
        tagline: s.tagline,
        url: s.url,
        iconUrl: s.iconUrl ?? undefined,
        category: s.category,
        status: s.status,
        revenue: s.revenue,
      })),
  }
}
